import Q1 from './q1'
import Q2 from './q2'
import Q3 from './q3'
import Q6 from './q6'
import Q7 from './q7'
import RES from './res'

export default {
  meta: {
    name: 'Deuter',
    version: 'V01.00',
    disabledFullScreens: ['PRE0'],
    advisor: 'Peter',
    apiURL: process.env.VUE_APP_API_URL
  },
  levels: [
    {
      id: 'PRE0',
      componentType: 'start-screen',
      options: {
        image: '/product-advisor/images/welcome.svg',
        header: 'startScreen.header',
        question: 'startScreen.question',
        answers: [
          { text: 'startScreen.answer_1', action: 'jump:PRE1' },
          { text: 'startScreen.answer_2', action: 'quit' },
        ]
      }
    },
    {
      id: 'PRE1',
      componentType: 'greeting-screen',
      progress: '/product-advisor/images/progress/Ladebalken_Berge_1029x232px_1.png',
      options: {
        image: '/product-advisor/images/greetings.svg',
        question: 'greetingScreen.title',
        answers: [
          { text: 'greetingScreen.answer_1', action: 'jump:Q1' }
        ]
      }
    },
  ]
  .concat(Q1)
  .concat(Q2)
  .concat(Q3)
  .concat(Q6)
  .concat(Q7)
  .concat(RES)
}